module.exports = function() {
  return new Worker(__webpack_public_path__ + "b5b1ae031185c0982b5f.worker.js");
};